import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RevenueInvoiceSettingsService {

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get(`${environment.url}/revenue_invoice_settings`).pipe(map((res: any) => res['hydra:member'])) as Observable<
      any[]
    >;
  }
}
